import React, { Fragment } from 'react';

import { ArrowLeftOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Input, Tooltip } from 'antd';

import FaqLink from './FaqLink';
import FacebookForm from '../FacebookForm';
import Platforms, { enTypePlatform } from '../Platforms';

interface IProps {
  conversionLabel: string;
  domain: string;
  hasDomain: boolean;
  tokenApi: string;
  loading: boolean;
  platformType: enTypePlatform;
  pixel: string;
  pixelId: string;
  validated: boolean;
  handleConversionLabel: (conversionLabel: string) => void;
  handlePixel: (pixel: string) => void;
  handleDelete: (idPixel: any, type: string) => Promise<void>;
  handleDomain: (domain: string) => void;
  handleTokenApi: (tokenApi: string) => void;
  handleReload: () => void;
  back: () => void;
}

function Basic({
  domain,
  validated,
  platformType,
  loading,
  conversionLabel,
  tokenApi,
  hasDomain,
  pixel,
  pixelId,
  handleConversionLabel,
  handleTokenApi,
  handleDelete,
  handlePixel,
  handleReload,
  handleDomain,
  back
}: IProps) {
  const platform = (Platforms || []).find(x => x.type === platformType);

  const imgUrl = platform?.image || '';
  const label = platform?.label || '';
  return (
    <Fragment>
      {platformType != null && (
        <div>
          <div className='flex items-center'>
            <Tooltip title='Voltar' placement='top'>
              <Button
                type='text'
                shape='circle'
                onClick={() => back()}
                style={{ marginRight: 8 }}
                icon={<ArrowLeftOutlined />}
              />
            </Tooltip>
            <img src={imgUrl} alt='platform' className='max-h-[30px] max-w-full' />
          </div>
          <div className='mt-8' />
          <div>
            <div className='flex items-end'>
              <div>
                <label className='mb-1 block text-sm'>{label}</label>
                <Input value={pixel} onChange={(e: any) => handlePixel(e.target.value)} />
              </div>
              {pixelId !== '' && (
                <Tooltip title='Deletar Pixel' placement='top'>
                  <Button
                    type='text'
                    style={{ marginLeft: 8 }}
                    onClick={() => handleDelete(pixelId, platformType)}
                    icon={<DeleteOutlined />}
                  />
                </Tooltip>
              )}
            </div>
            {platformType !== enTypePlatform.FACEBOOK && <FaqLink link={platform.faqUrl} />}

            <div className='mt-8' />

            {platformType === enTypePlatform.FACEBOOK && (
              <FacebookForm
                handleReload={handleReload}
                loading={loading}
                tokenApi={tokenApi}
                handleTokenApi={handleTokenApi}
                hasDomain={hasDomain}
                validated={validated}
                handleDomain={handleDomain}
                domain={domain}
              />
            )}
            {platformType === enTypePlatform.ADWORDS && (
              <Fragment>
                <div className='mt-6' />
                <div className='flex items-end'>
                  <div>
                    <label className='mb-1 block text-sm'>Label de conversão</label>
                    <Input value={conversionLabel} onChange={(e: any) => handleConversionLabel(e.target.value)} />
                  </div>
                </div>
              </Fragment>
            )}
          </div>
          <div className='mt-2' />
        </div>
      )}
    </Fragment>
  );
}

export default Basic;
